export default __webpack_public_path__ + "static/media/Nicky.334c12ec.png";